import { Check } from "lucide-react";
import type { ReactNode } from "react";

interface OnboardingValueBlockProps {
  /** Mono uppercase title, e.g. "Lo que vas a tener al final". */
  head: ReactNode;
  /** Bullet list items — each rendered with an olive check tile. */
  items: ReactNode[];
  /** Optional right-side label in the head row (e.g. "En vivo" for the DGI feed). */
  headRight?: ReactNode;
}

/**
 * Dark translucent panel with mono uppercase header + olive-tile check
 * items. Used in the brand column for trust statements and outcome lists.
 */
export function OnboardingValueBlock({
  head,
  items,
  headRight,
}: OnboardingValueBlockProps): JSX.Element {
  return (
    <div className="fx-onb-value-block">
      <div
        className="vb-head"
        style={
          headRight
            ? { display: "flex", justifyContent: "space-between" }
            : undefined
        }
      >
        <span>{head}</span>
        {headRight ? <span>{headRight}</span> : null}
      </div>
      <ul>
        {items.map((it, i) => (
          <li key={i}>
            <span className="ico">
              <Check aria-hidden />
            </span>
            <span>{it}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
